import { IUseToastNotification, useToastNotification } from '@mondra/ui-components'


export const NOTIFICATION_POSITION: IUseToastNotification = { position: 'top-center' }

export function useTopCenterToast() {
    return useToastNotification(NOTIFICATION_POSITION)
}
